import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-success',
  templateUrl: './forgot-success.component.html',
  styleUrls: ['./forgot-success.component.scss'],
})
export class ForgotSuccessComponent implements OnInit {
  @Input() username!: string;
  @Input() onBackToSignIn!: () => void;

  message = '';

  constructor() {}

  ngOnInit(): void {
    this.message = `Email has been sent to ${this.username} with instructions on resetting your password.`;
  }

  onSubmit(): void {
    this.onBackToSignIn();
  }
}
